import { render, staticRenderFns } from "./DashboardCircuitos.vue?vue&type=template&id=45d406ca"
import script from "./DashboardCircuitos.vue?vue&type=script&lang=js"
export * from "./DashboardCircuitos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports